import Immutable from 'seamless-immutable';
import { createReducer } from 'redux-act';

import IntegrationActions from './integration-actions';

const initialState = Immutable({
  byId:       {},
  allIds:     [],
  isFetching: false,
});

export default createReducer(on => {
  // ################################################################################################################
  // INTEGRATION TEMPLATES
  // ################################################################################################################

  on(IntegrationActions.fetchIntegrationTemplates, state => {
    return state.set('isFetching', true);
  });

  on(IntegrationActions.fetchIntegrationTemplatesFailure, state => {
    return state.set('isFetching', false);
  });

  on(IntegrationActions.fetchIntegrationTemplatesSuccess, (state, { integrationTemplates }) => {
    const byId = {};
    const allIds = [];

    integrationTemplates.forEach(template => {
      byId[template.id] = template;
      allIds.push(template.id);
    });

    return state
      .merge({
        byId,
        allIds,
      })
      .set('isFetching', false);
  });
}, initialState);
